import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div style={{ textAlign: "center", padding: "50px" }}>
    <img 
      src="https://lenim.s3.ap-northeast-1.amazonaws.com/1736233334545-404page.png" 
      alt="404 Not Found" 
      style={{ width: "40%", height: "auto", marginBottom: "20px" }} 
    />
    <h1 style={{ fontSize: "3rem", margin: "20px 0" }}>404</h1>
    <p style={{ fontSize: "1.5rem", margin: "10px 0" }}>Page Not Found</p>
    <Link to="/" style={{ color: "#007BFF", textDecoration: "none", fontSize: "1.2rem" }}>
      Go Back to Home
    </Link>
  </div>
);

export default NotFound;
